import { render, staticRenderFns } from "./OrderProductDetail.vue?vue&type=template&id=fa13f44e"
import script from "./OrderProductDetail.vue?vue&type=script&lang=js"
export * from "./OrderProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports